// extracted by mini-css-extract-plugin
export var orderDetails = "_st-2";
export var orderImage = "_st-1";
export var orderMeta = "_st-3";
export var orderSummary = "_st-0";
export var rightArrow = "_st-4";